import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { Context } from "../../context/Context";
import "./Remote.css";
import EquipmentButtonIcons from "../../constants/EquipmentButtonIcon";
import {
  DeleteEquipmentButton,
  DeleteEquipments,
  UpdateEquipmentButton,
  UpdateEquipments,
} from "../../api/api";
import { Link, useNavigate, useParams } from "react-router-dom";
import SuccessToast from "../toasts/SuccessToast";
import { MqttContext } from "../../context/MQTTContext";
import WarningAlert from "../sweeAlerts/WarningAlert";
import ErrorToast from "../toasts/ErrorToast";
import SetDataFormat from "../modals/SetDataFormat";
import EditChartNumberModal from "../modals/EditChartNumberModal";
import DefineChartModal from "../modals/DefineChartModal";

const DataLogger = () => {
  const {
    handleEquipmentButtonIconModal,
    setEditEquipmentButton,
    authUser,
    setIsLoading,
    equipmentButtons,
    setEquipmentButtons,
    devices,
    equipments,
    setEquipments,
    handleEquipmentsListModal,
    setSelectedEquipment,
    setChangeNameOptions,
    handleChangeNameModal,
    handleSetDataFormat,
    handleEditChartNumberModal,
    handleDefineChartModal,
    selectedEquipment,
    handleChartModal,
    setChartInfo,
    refreshMqtt,
    currentRoom,
  } = useContext(Context);
  const { clients } = useContext(MqttContext);
  const [buttons, setButtons] = useState([]);
  const [buttonStates, setButtonStates] = useState({});
  const [update, setUpdate] = useState(false);
  const [singleRegisterValues, setSingleRegisterValues] = useState({});
  const [clickedButtons, setClickedButtons] = useState({});
  const [inputsValue, setInputsValue] = useState({});
  const [buttonShouldBeChange, setButtonShouldBeChange] = useState({});

  const { equipment_id: eq_id, room_id, equipment_type: eq_type } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    let btns = equipmentButtons
      .filter((eq_btn) => eq_btn.equipment_id == eq_id)
      .map((btn) => ({
        ...btn,
        digit: Number(btn.digit),
      }));

    setButtons(btns);
    setSelectedEquipment({
      id: eq_id,
      type: eq_type,
    });
    if (btns.length) {
      btns.forEach((button) => {
        if (
          (button.digit || button.digit != null) &&
          (button.data1 || button.data1 != null) &&
          (button.data2 || button.data2 != null) &&
          (button.data3 || button.data3 != null) &&
          (button.data4 || button.data4 != null) &&
          (button.data1 == 1 ||
            button.data1 == 2 ||
            button.data1 == 3 ||
            button.data1 == 4)
        ) {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            const messageListener = (topic, message) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) +
                String.fromCharCode(message[1]);
              const deviceSerial =
                String.fromCharCode(message[3]) +
                String.fromCharCode(message[4]) +
                String.fromCharCode(message[5]) +
                String.fromCharCode(message[6]) +
                String.fromCharCode(message[7]) +
                String.fromCharCode(message[8]);
              if (
                device.bridge_device.internet_token.slice(-2) ===
                  endOfTwoCharToken &&
                device.serial === deviceSerial &&
                message[10] == 1 &&
                message[2] == 14 &&
                message[11] == button.digit
              ) {
                let dataShouldBeCheckCRC = [
                  message[11],
                  message[12],
                  ...message.slice(13, 14 + message[5]),
                ];
                let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
                if (
                  (crc16[0] != message[message.length - 2] ||
                    crc16[1] != message[message.length - 1]) &&
                  (button.digit != message[11] || button.data1 != message[12])
                ) {
                  return;
                }
                if (message[12] == 1 || message[12] == 2) {
                  let value = bytesToDecimal(
                    message.slice(14, 14 + message[13]).reverse(),
                  );
                  setButtonStates((prev) => ({
                    ...prev,
                    [button.id]: value,
                  }));
                } else if (message[12] == 3 || message[12] == 4) {
                  let value = message.slice(5, 6 + message[13]);
                  value = parseUint8ArrayTo16BitDecimals(value);
                  setInputsValue((prev) => ({
                    ...prev,
                    [button.id]: value,
                  }));
                }
              }
            };

            // clients[button.device.bridge_device.id].removeAllListeners("message");
            clients[device.bridge_device.id].on("message", messageListener);

            let buffer = new ArrayBuffer(17);
            let asciiCode = new Uint8Array(buffer);
            asciiCode[0] = 14;
            asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
            asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
            asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
            asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
            asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
            asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
            asciiCode[7] = device.type + 50;
            asciiCode[8] = 1;
            asciiCode[9] = button.digit; // Slave Address
            asciiCode[10] = button.data1; // Function code
            asciiCode[11] = button.data2; // Address (High byte)
            asciiCode[12] = button.data3; // Address (Low byte)
            asciiCode[13] = 0; // Quantity (High byte)
            asciiCode[14] = button.data4; // Quantity (Low byte)
            let crc16 = calculateCRC16Modbus([
              button.digit,
              button.data1,
              button.data2,
              button.data3,
              0,
              button.data4,
            ]);
            asciiCode[15] = crc16[0]; // Low byte
            asciiCode[16] = crc16[1]; // High byte

            let message = device.bridge_device.internet_token;
            // ترکیب رشته و بافر
            let combinedMessage = concatenateStringAndBuffer(
              message,
              asciiCode,
            );
            clients[device.bridge_device.id].publish(
              device.bridge_device.serial + "/sys",
              combinedMessage,
            );
            // clientsId = [...clientsId, device.id];
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            const messageListener = (topic, message) => {
              const endOfTwoCharToken =
                String.fromCharCode(message[0]) +
                String.fromCharCode(message[1]);
              if (
                device.internet_token.slice(-2) === endOfTwoCharToken &&
                message[2] == 1 &&
                button.digit == message[3]
              ) {
                let dataShouldBeCheckCRC = [
                  message[3],
                  message[4],
                  ...message.slice(5, 6 + message[5]),
                ];
                let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
                if (
                  (crc16[0] != message[message.length - 2] ||
                    crc16[1] != message[message.length - 1]) &&
                  (button.digit != message[3] || button.data1 != message[4])
                ) {
                  return;
                }
                if (message[4] == 1 || message[4] == 2) {
                  let value = bytesToDecimal(
                    message.slice(6, 6 + message[5]).reverse(),
                  );
                  setButtonStates((prev) => ({
                    ...prev,
                    [button.id]: value,
                  }));
                } else if (message[4] == 3 || message[4] == 4) {
                  let value = message.slice(5, 6 + message[5]);
                  value = parseUint8ArrayTo16BitDecimals(value);
                  setInputsValue((prev) => ({
                    ...prev,
                    [button.id]: value,
                  }));
                }
              }
            };
            // clients[button.device.id].removeAllListeners("message");
            clients[device.id].on("message", messageListener);

            let buffer = new ArrayBuffer(9);
            let asciiCode = new Uint8Array(buffer);
            asciiCode[0] = 1;
            asciiCode[1] = button.digit; // Slave Address
            asciiCode[2] = button.data1; // Function code
            asciiCode[3] = button.data2; // Address (High byte)
            asciiCode[4] = button.data3; // Address (Low byte)
            asciiCode[5] = 0; // Quantity (High byte)
            asciiCode[6] = button.data4; // Quantity (Low byte)
            let crc16 = calculateCRC16Modbus([
              button.digit,
              button.data1,
              button.data2,
              button.data3,
              0,
              button.data4,
            ]);
            asciiCode[7] = crc16[0]; // Low byte
            asciiCode[8] = crc16[1]; // High byte

            let message = device.internet_token;
            // ترکیب رشته و بافر
            let combinedMessage = concatenateStringAndBuffer(
              message,
              asciiCode,
            );
            clients[device.id].publish(device.serial + "/sys", combinedMessage);
          }
        }
      });

      return () => {
        buttons.forEach((button) => {
          let device = devices.find((d) => d.id == button.device_id);
          if (!device) {
            return;
          }
          if (!device) {
            return;
          }
          if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
            clients[device.bridge_device.id].removeAllListeners("message");
          } else if (
            device.id &&
            device.username &&
            device.password &&
            clients[device.id]
          ) {
            clients[device.id].removeAllListeners("message");
          }
        });
      };
    }
  }, [update, equipmentButtons, refreshMqtt, eq_id]);

  const parseUint8ArrayTo16BitDecimals = (uint8Array) => {
    const totalBytes = uint8Array[0]; // تعداد کل بایت‌های داده
    const dataBytes = uint8Array.slice(1, 1 + totalBytes);
    const view = new DataView(
      dataBytes.buffer,
      dataBytes.byteOffset,
      dataBytes.byteLength,
    );
    const result = [];

    for (let i = 0; i < dataBytes.length; i += 2) {
      const value = view.getUint16(i, false);
      result.push(value);
    }

    return result;
  };
  const bytesToDecimal = (bytes) => {
    return bytes.reduce((acc, byte) => acc * 256 + byte, 0);
  };

  const concatenateStringAndBuffer = (str, buffer) => {
    let encoder = new TextEncoder();
    let encodedString = encoder.encode(str); // تبدیل رشته به بایت‌ها

    // ساخت یک بافر جدید که به اندازه رشته و بافر اصلی است
    let newBuffer = new Uint8Array(encodedString.length + buffer.byteLength);

    // قرار دادن رشته در ابتدا
    newBuffer.set(encodedString, 0);

    // قرار دادن بافر در ادامه
    newBuffer.set(new Uint8Array(buffer), encodedString.length);

    return newBuffer;
  };

  const calculateCRC16Modbus = (buffer) => {
    let crc = 0xffff;

    for (let i = 0; i < buffer.length; i++) {
      crc ^= buffer[i];
      for (let j = 0; j < 8; j++) {
        if ((crc & 0x0001) !== 0) {
          crc = (crc >> 1) ^ 0xa001;
        } else {
          crc = crc >> 1;
        }
      }
    }

    const lowByte = crc & 0xff;
    const highByte = (crc >> 8) & 0xff;

    return [lowByte, highByte]; // ترتیب: low byte, high byte (مطابق با Modbus)
  };

  const handleRemoveButton = (e, button) => {
    let equipment_buttons_ids = null;
    if (
      button.data1 == 1 ||
      button.data1 == 2 ||
      button.data1 == 3 ||
      button.data1 == 4
    ) {
      equipment_buttons_ids = buttons
        .filter((b) => b.digit == button.id)
        .map((b) => b.id);
    }
    setIsLoading(true);
    e.preventDefault();
    DeleteEquipmentButton({
      equipment_button_id: button.id,
      equipment_buttons_ids,
    }).then((res) => {
      let btns = equipmentButtons.filter((b) => b.id != button.id);
      if (equipment_buttons_ids) {
        btns.filter((b) => !equipment_buttons_ids.includes(b.id));
      }
      setEquipmentButtons(btns);
      SuccessToast("با موفقیت حذف گردید");
      setIsLoading(false);
    });
  };

  const handleChangeNameButton = (button) => {
    const onSubmitFunc = ({ button, name }) => {
      UpdateEquipmentButton({
        equipment_button_id: button.id,
        name: name,
        digit: button.digit,
        icon: button.icon,
        data: [
          button.data1,
          button.data2,
          button.data3,
          button.data4,
          button.data5,
        ],
      }).then((res) => {
        if (res.status == 200) {
          SuccessToast("با موفقیت ثبت شد");

          const index = equipmentButtons.findIndex(
            (item) => item.id == button.id,
          );

          if (index !== -1) {
            const updatedButtons = [...equipmentButtons];
            updatedButtons[index] = {
              ...updatedButtons[index],
              name: name,
            };

            setEquipmentButtons(updatedButtons);
          }
        }
      });
    };
    const newOptions = {
      name: button.name,
      onSubmit: (newName) => {
        onSubmitFunc({ button, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };

  const handleChangeEquipmentName = (equipment_id) => {
    const onSubmitFunc = ({ equipment_id, name }) => {
      UpdateEquipments({
        equipment_id,
        name,
      }).then((res) => {
        const updatedEquipments = equipments.map((item) =>
          item.id == equipment_id
            ? {
                ...item,
                equipment: { ...item.equipment, name: name },
              }
            : item,
        );
        setEquipments(updatedEquipments);
      });
    };
    const newOptions = {
      name:
        equipments.find((eq) => eq.id == equipment_id)?.equipment.name ?? "",
      onSubmit: (newName) => {
        onSubmitFunc({ equipment_id, name: newName });
      },
    };
    setChangeNameOptions(newOptions);
    handleChangeNameModal();
  };
  const handleRemoveEquipment = (equipment_id) => {
    WarningAlert(
      "آیا از حذف این تجهیز اطمینان دارید؟",
      "",
      "تایید",
      "انصراف",
    ).then(function (result) {
      if (result.value) {
        DeleteEquipments({ equipment_id }).then((res) => {
          SuccessToast(res.data.message);
          let newEquipments = equipments.filter((eq) => eq.id != equipment_id);
          setEquipments(newEquipments);
          let lstEquipment = newEquipments.find(
            (eq) => eq.room_id == currentRoom,
          );
          handleEquipment(lstEquipment, currentRoom);
        });
      }
    });
  };

  const handleEquipment = (equipment, roomId) => {
    if (!equipment) return navigate("/room/" + roomId);
    equipment = equipment.equipment;
    setSelectedEquipment({
      id: equipment.id,
      type: equipment.type,
    });
    if (!equipment) {
      return navigate("/");
    } else if (equipment.type == 1) {
      return navigate(
        "/room/key/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 3) {
      return navigate(
        "/room/remote/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 4) {
      return navigate(
        "/room/dimmer/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 5) {
      return navigate(
        "/room/thermostat/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 9) {
      return navigate(
        "/room/rgb/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 99) {
      return navigate(
        "/room/wireless-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 100) {
      return navigate(
        "/room/television/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 501) {
      return navigate(
        "/room/fan-coil/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 401) {
      return navigate(
        "/room/scenario-key/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 503) {
      return navigate(
        "/room/humidity/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 502) {
      return navigate(
        "/room/motor/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9998) {
      return navigate(
        "/room/input/" + roomId + "/" + equipment.id + "/" + equipment.type,
      );
    } else if (equipment.type == 9999) {
      return navigate(
        "/room/input-status/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    } else if (equipment.type == 600) {
      return navigate(
        "/room/data-logger/" +
          roomId +
          "/" +
          equipment.id +
          "/" +
          equipment.type,
      );
    }
  };

  const handleSingleCoil = (button, status) => {
    let device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    setClickedButtons((prev) => ({
      ...prev,
      [button.id]: true,
    }));
    if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        const deviceSerial =
          String.fromCharCode(message[3]) +
          String.fromCharCode(message[4]) +
          String.fromCharCode(message[5]) +
          String.fromCharCode(message[6]) +
          String.fromCharCode(message[7]) +
          String.fromCharCode(message[8]);
        if (
          device.bridge_device.internet_token.slice(-2) === endOfTwoCharToken &&
          device.serial === deviceSerial &&
          message[10] == 1 &&
          message[2] == 14 &&
          message[11] == button.digit
        ) {
          let dataShouldBeCheckCRC = [
            message[11],
            message[12],
            ...message.slice(13, 14 + message[13]),
          ];
          let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
          if (
            (crc16[0] != message[message.length - 2] ||
              crc16[1] != message[message.length - 1]) &&
            (button.digit != message[11] || button.data1 != message[12])
          ) {
            return;
          }

          setClickedButtons((prev) => ({
            ...prev,
            [button.id]: false,
          }));
        }
      };

      clients[button.device.bridge_device.id].removeAllListeners("message");
      clients[device.bridge_device.id].on("message", messageListener);

      let buffer = new ArrayBuffer(17);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50;
      asciiCode[8] = 1;
      asciiCode[9] = button.digit; // Slave Address
      asciiCode[10] = button.data1; // Function code
      asciiCode[11] = button.data2; // Address (High byte)
      asciiCode[12] = button.data3; // Address (Low byte)
      if (status == 1) {
        asciiCode[13] = 255;
        asciiCode[14] = 0;
      } else {
        asciiCode[13] = 0;
        asciiCode[14] = 0;
      }
      let crc16 = calculateCRC16Modbus([
        button.digit,
        button.data1,
        button.data2,
        button.data3,
        asciiCode[13],
        asciiCode[14],
      ]);
      asciiCode[15] = crc16[0]; // Low byte
      asciiCode[16] = crc16[1]; // High byte

      let message = device.bridge_device.internet_token;
      // ترکیب رشته و بافر
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.bridge_device.id].publish(
        device.bridge_device.serial + "/sys",
        combinedMessage,
      );
      // clientsId = [...clientsId, device.id];
    } else if (
      device.id &&
      device.username &&
      device.password &&
      clients[device.id]
    ) {
      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        if (
          device.internet_token.slice(-2) === endOfTwoCharToken &&
          message[2] == 1 &&
          button.digit == message[3]
        ) {
          let dataShouldBeCheckCRC = [
            message[3],
            message[4],
            ...message.slice(5, 6 + message[5]),
          ];
          let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
          if (
            (crc16[0] != message[message.length - 2] ||
              crc16[1] != message[message.length - 1]) &&
            (button.digit != message[3] || button.data1 != message[4])
          ) {
            return;
          }

          setClickedButtons((prev) => ({
            ...prev,
            [button.id]: false,
          }));
        }
      };
      // clients[button.device.id].removeAllListeners("message");
      clients[device.id].on("message", messageListener);

      let buffer = new ArrayBuffer(9);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 1;
      asciiCode[1] = button.digit; // Slave Address
      asciiCode[2] = button.data1; // Function code
      asciiCode[3] = button.data2; // Address (High byte)
      asciiCode[4] = button.data3; // Address (Low byte)
      if (status == 1) {
        asciiCode[5] = 255;
        asciiCode[6] = 0;
      } else {
        asciiCode[5] = 0;
        asciiCode[6] = 0;
      }
      let crc16 = calculateCRC16Modbus([
        button.digit,
        button.data1,
        button.data2,
        button.data3,
        asciiCode[5],
        asciiCode[6],
      ]);
      asciiCode[7] = crc16[0]; // Low byte
      asciiCode[8] = crc16[1]; // High byte

      let message = device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.id].publish(device.serial + "/sys", combinedMessage);
    }
  };

  const handleChangeSingleRegisterValue = (button, value) => {
    if (value === "" || value === null || value === undefined) {
      setSingleRegisterValues((prev) => ({
        ...prev,
        [button.id]: "",
      }));
      return;
    }

    const numValue = parseFloat(value);
    if (isNaN(numValue)) {
      return;
    }

    // محاسبه مقدار نهایی با در نظر گرفتن ضریب
    const multipliedValue = numValue * (button.data5 || 1);

    // بررسی محدودیت 65535
    if (multipliedValue > 65535) {
      const maxAllowed = Math.floor(65535 / (button.data5 || 1));
      setSingleRegisterValues((prev) => ({
        ...prev,
        [button.id]: maxAllowed,
      }));
      return;
    }

    if (multipliedValue < 0) {
      setSingleRegisterValues((prev) => ({
        ...prev,
        [button.id]: 0,
      }));
      return;
    }

    setSingleRegisterValues((prev) => ({
      ...prev,
      [button.id]: numValue,
    }));
  };

  const handleSendSingleRegisterValue = (button) => {
    let device = devices.find((d) => d.id == button.device_id);
    if (!device) {
      return;
    }
    if (isNaN(singleRegisterValues[button.id])) {
      return ErrorToast("مقدار ورودی صحیح نیست");
    }

    setClickedButtons((prev) => ({
      ...prev,
      [button.id]: true,
    }));

    if (device.is_bus == 1 && clients[device?.bridge_device?.id]) {
      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        const deviceSerial =
          String.fromCharCode(message[3]) +
          String.fromCharCode(message[4]) +
          String.fromCharCode(message[5]) +
          String.fromCharCode(message[6]) +
          String.fromCharCode(message[7]) +
          String.fromCharCode(message[8]);
        if (
          device.bridge_device.internet_token.slice(-2) === endOfTwoCharToken &&
          device.serial === deviceSerial &&
          message[10] == 1 &&
          message[2] == 14
        ) {
          let dataShouldBeCheckCRC = [
            message[11],
            message[12],
            ...message.slice(13, 14 + message[13]),
          ];
          let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
          if (
            (crc16[0] != message[message.length - 2] ||
              crc16[1] != message[message.length - 1]) &&
            (button.digit != message[11] || button.data1 != message[12])
          ) {
            return;
          }

          setClickedButtons((prev) => ({
            ...prev,
            [button.id]: false,
          }));
        }
      };

      // clients[button.device.bridge_device.id].removeAllListeners("message");
      clients[device.bridge_device.id].on("message", messageListener);

      let buffer = new ArrayBuffer(17);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 14;
      asciiCode[1] = `${device.serial[0]}`.charCodeAt(0);
      asciiCode[2] = `${device.serial[1]}`.charCodeAt(0);
      asciiCode[3] = `${device.serial[2]}`.charCodeAt(0);
      asciiCode[4] = `${device.serial[3]}`.charCodeAt(0);
      asciiCode[5] = `${device.serial[4]}`.charCodeAt(0);
      asciiCode[6] = `${device.serial[5]}`.charCodeAt(0);
      asciiCode[7] = device.type + 50;
      asciiCode[8] = 1;
      asciiCode[9] = button.digit; // Slave Address
      asciiCode[10] = button.data1; // Function code
      asciiCode[11] = button.data2; // Address (High byte)
      asciiCode[12] = button.data3; // Address (Low byte)
      asciiCode[13] =
        ((singleRegisterValues[button.id] * button.data5) >> 8) & 0xff;
      asciiCode[14] = (singleRegisterValues[button.id] * button.data5) & 0xff;
      let crc16 = calculateCRC16Modbus([
        asciiCode[9],
        asciiCode[10],
        asciiCode[11],
        asciiCode[12],
        asciiCode[13],
        asciiCode[14],
      ]);
      asciiCode[15] = crc16[0]; // Low byte
      asciiCode[16] = crc16[1]; // High byte

      let message = device.bridge_device.internet_token;
      // ترکیب رشته و بافر
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.bridge_device.id].publish(
        device.bridge_device.serial + "/sys",
        combinedMessage,
      );
      // clientsId = [...clientsId, device.id];
    } else if (
      device.id &&
      device.username &&
      device.password &&
      clients[device.id]
    ) {
      const messageListener = (topic, message) => {
        const endOfTwoCharToken =
          String.fromCharCode(message[0]) + String.fromCharCode(message[1]);
        if (
          device.internet_token.slice(-2) === endOfTwoCharToken &&
          message[2] == 1 &&
          button.digit == message[3]
        ) {
          let dataShouldBeCheckCRC = [
            message[3],
            message[4],
            ...message.slice(5, 6 + message[5]),
          ];
          let crc16 = calculateCRC16Modbus(dataShouldBeCheckCRC);
          if (
            (crc16[0] != message[message.length - 2] ||
              crc16[1] != message[message.length - 1]) &&
            (button.digit != message[3] || button.data1 != message[4])
          ) {
            return;
          }

          setClickedButtons((prev) => ({
            ...prev,
            [button.id]: false,
          }));
        }
      };
      // clients[button.device.id].removeAllListeners("message");
      clients[device.id].on("message", messageListener);

      let buffer = new ArrayBuffer(9);
      let asciiCode = new Uint8Array(buffer);
      asciiCode[0] = 1;
      asciiCode[1] = button.digit; // Slave Address
      asciiCode[2] = button.data1; // Function code
      asciiCode[3] = button.data2; // Address (High byte)
      asciiCode[4] = button.data3; // Address (Low byte)
      asciiCode[5] =
        ((singleRegisterValues[button.id] * button.data5) >> 8) & 0xff;
      asciiCode[6] = (singleRegisterValues[button.id] * button.data5) & 0xff;
      let crc16 = calculateCRC16Modbus([
        asciiCode[1],
        asciiCode[2],
        asciiCode[3],
        asciiCode[4],
        asciiCode[5],
        asciiCode[6],
      ]);
      asciiCode[7] = crc16[0]; // Low byte
      asciiCode[8] = crc16[1]; // High byte

      let message = device.internet_token;
      let combinedMessage = concatenateStringAndBuffer(message, asciiCode);
      clients[device.id].publish(device.serial + "/sys", combinedMessage);
    }
  };

  const renderFirstBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 1 || button.data1 == 2) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) return null;

        let btns = buttons.filter((btn) => btn.digit == button.id);
        let status = buttonStates[button.id];
        return (
          <React.Fragment key={button.id}>
            <div className="card p-2 m-2">
              <div
                className="card-header m-0 p-0 mb-3"
                style={{
                  zIndex: "1",
                  position: "relative",
                  top: 0,
                  width: "max-content",
                }}
              >
                {authUser.is_admin && (
                  <div
                    className="btn-group d-inline-block"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul className="dropdown-menu">
                      {button.data5 ? (
                        <li
                          onClick={() => {
                            setChartInfo({
                              type: 1,
                              device_type: 16,
                              bit:
                                button.data1 == 1 || button.data1 == 2 ? 1 : 0,
                              device_id: button.device_id,
                              chart_num: button.data5,
                              first_index: 1,
                              count: button.data4,
                              coefficients: btns.map((item) => item.data5),
                              names: btns.map((item) => item.name),
                            });
                            handleChartModal();
                          }}
                        >
                          <a className="dropdown-item">نمایش نمودار</a>
                        </li>
                      ) : null}

                      <li
                        onClick={() => {
                          setButtonShouldBeChange(button);
                          handleEditChartNumberModal();
                        }}
                      >
                        <a className="dropdown-item">ویرایش نمودار</a>
                      </li>
                      <li onClick={(e) => handleRemoveButton(e, button)}>
                        <a className="dropdown-item">حذف</a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div className="card-body">
                <div className="d-flex flex-wrap">
                  {btns.map((btn, index) => {
                    let iconPath = "/assets/img/custom-equipment-button/19.png";
                    if (btn.icon) {
                      let buttonIcon = EquipmentButtonIcons.find(
                        (icon) => icon.id == btn.icon,
                      );
                      if (buttonIcon) iconPath = buttonIcon.path;
                    }

                    let buttonState = !isNaN(status)
                      ? (status >> index) & 1
                      : 2;
                    return (
                      <div className="remote" key={btn.id}>
                        {authUser.is_admin && (
                          <div
                            className="btn-group d-inline-block"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="bx bx-dots-vertical-rounded"></i>
                            </button>
                            <ul className="dropdown-menu">
                              <li
                                onClick={() => {
                                  handleEquipmentButtonIconModal(true);
                                  setEditEquipmentButton(btn);
                                }}
                              >
                                <a className="dropdown-item">تغییر آیکون</a>
                              </li>
                              <li
                                onClick={() => {
                                  handleChangeNameButton(btn);
                                }}
                              >
                                <a className="dropdown-item">تغییر نام</a>
                              </li>
                            </ul>
                          </div>
                        )}
                        <div className="icon-part">
                          <img src={iconPath} alt="" />
                        </div>
                        <div
                          className={
                            buttonState == 1
                              ? "status-part bg-success"
                              : buttonState == 0
                                ? "status-part bg-danger"
                                : "status-part"
                          }
                        ></div>
                        <div className="info-part">
                          <p className="text-center p-0 m-0 d-block">
                            {btn.name}
                          </p>
                          <p
                            className="text-center p-0 m-0"
                            style={{ fontSize: "11px" }}
                          >
                            S/{device.serial}/{button.digit}/
                            {(btn.data2 << 8) | btn.data3}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
      return null;
    });
  };

  const renderSecondBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 3 || button.data1 == 4) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        let btns = buttons.filter((btn) => btn.digit == button.id);
        let values = inputsValue[button.id];
        return (
          <React.Fragment key={button.id}>
            <tr className="group bg-light">
              <td colSpan="8">
                {authUser.is_admin && (
                  <div
                    className="btn-group d-inline-block"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bx bx-dots-vertical-rounded"></i>
                    </button>
                    <ul className="dropdown-menu ">
                      {button.data5 ? (
                        <li
                          onClick={() => {
                            setChartInfo({
                              type: 1,
                              device_type: 16,
                              bit:
                                button.data1 == 1 || button.data1 == 2 ? 1 : 0,
                              device_id: button.device_id,
                              chart_num: button.data5,
                              first_index: 1,
                              count: button.data4,
                              coefficients: btns.map((item) => item.data5),
                              names: btns.map((item) => item.name),
                            });
                            handleChartModal();
                          }}
                        >
                          <a className="dropdown-item">نمایش نمودار</a>
                        </li>
                      ) : null}
                      <li
                        onClick={() => {
                          if (btns.length > 8)
                            return ErrorToast(
                              "حداکثر تعداد مجاز برای نمایش نمودار 8 عدد است",
                            );
                          setButtonShouldBeChange(button);
                          handleEditChartNumberModal();
                        }}
                      >
                        <a className="dropdown-item">ویرایش نمودار</a>
                      </li>
                      <li onClick={(e) => handleRemoveButton(e, button)}>
                        <a className="dropdown-item">حذف</a>
                      </li>
                    </ul>
                  </div>
                )}
              </td>
            </tr>
            {btns.map((btn, index) => {
              let value = "-";
              btn.data5 = btn.data5 ?? 1;
              let signed = btn.data5.toString(2).padStart(8, "0")[7];
              let devided = btn.data5 & 0x7f;
              if (values?.[index]) {
                if (signed) {
                  if (values?.[index] > 32767) {
                    value = ((values?.[index] - 65536) / devided).toFixed(2);
                  } else {
                    value = (values?.[index] / devided).toFixed(2) ?? 0;
                  }
                } else {
                  value = (values?.[index] / devided).toFixed(2) ?? 0;
                }
              }
              return (
                <tr key={btn.id}>
                  <td>
                    {authUser.is_admin && (
                      <div
                        className="btn-group d-inline-block"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        }}
                      >
                        <button
                          type="button"
                          className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bx bx-dots-vertical-rounded"></i>
                        </button>
                        <ul className="dropdown-menu ">
                          <li
                            onClick={() => {
                              setButtonShouldBeChange(btn);
                              handleSetDataFormat();
                            }}
                          >
                            <a className="dropdown-item">تنظیم فرمت داده</a>
                          </li>
                          <li
                            onClick={() => {
                              handleChangeNameButton(btn);
                            }}
                          >
                            <a className="dropdown-item">تغییر نام</a>
                          </li>
                        </ul>
                      </div>
                    )}
                  </td>
                  <td>
                    <span>{value ?? "-"}</span>
                  </td>
                  <td>
                    <p className="m-0 p-0 text-end" style={{ width: "65px" }}>
                      {btn.name}
                    </p>
                    <span style={{ fontSize: "11px" }}>
                      S/{devices.find((d) => d.id == button.device_id).serial}/
                      {button.digit}/{(btn.data2 << 8) | btn.data3}
                    </span>
                  </td>
                </tr>
              );
            })}
          </React.Fragment>
        );
      }
    });
  };

  const renderThirdBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 5) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }
        let status = clickedButtons[button.id];
        return (
          <div className="remote" key={button.id} style={{ width: "100px" }}>
            {authUser.is_admin && (
              <div
                className="btn-group d-inline-block"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu ">
                  {/* <li
                    onClick={() => {
                      handleEquipmentButtonIconModal(true);
                      setEditEquipmentButton(button);
                    }}
                  >
                    <a className="dropdown-item">تغییر آیکون</a>
                  </li> */}
                  <li
                    onClick={() => {
                      handleChangeNameButton(button);
                    }}
                  >
                    <a className="dropdown-item">تغییر نام</a>
                  </li>
                  <li onClick={(e) => handleRemoveButton(e, button)}>
                    <a className="dropdown-item">حذف</a>
                  </li>
                </ul>
              </div>
            )}
            <div className="d-flex flex-wrap w-100">
              <div
                className="on-key w-50 p-1"
                onClick={() => handleSingleCoil(button, 1)}
              >
                <img
                  src="/assets/img/app-icons/on-key.png"
                  className="w-100"
                  alt="روشن"
                />
              </div>
              <div
                className="off-key w-50 p-1"
                onClick={() => handleSingleCoil(button, 0)}
              >
                <img
                  src="/assets/img/app-icons/off-key.png"
                  className="w-100"
                  alt="خاموش"
                />
              </div>
            </div>
            <div
              className={status ? "status-part bg-info " : "status-part"}
            ></div>
            <p className="m-0 p-0 text-center">{button.name}</p>
            <p className="text-center w-100" style={{ fontSize: "11px" }}>
              S/{devices.find((d) => d.id == button.device_id).serial}/
              {button.digit}/{(button.data2 << 8) | button.data3}{" "}
            </p>
          </div>
        );
      }
    });
  };

  const renderFourthBox = () => {
    return buttons.map((button) => {
      if (button.data1 == 6) {
        let device = devices.find((d) => d.id == button.device_id);
        if (!device) {
          return;
        }

        // محاسبه مقدار نمایش داده شده با دقت مناسب
        const inputValue = singleRegisterValues[button.id] ?? 0;
        const multipliedValue = !isNaN(inputValue)
          ? inputValue * button.data5
          : 0;

        // گرد کردن به 2 رقم اعشار برای نمایش بهتر
        const displayValue = !isNaN(inputValue)
          ? Number(inputValue).toFixed(2)
          : 0;
        const displayMultiplied = !isNaN(multipliedValue)
          ? Number(multipliedValue).toFixed(2)
          : 0;

        return (
          <div
            className="row mx-0 mt-3"
            style={{
              boxShadow: clickedButtons?.[button.id]
                ? "0 0.25rem 1rem rgba(0, 122, 255, 0.45)"
                : "",
            }}
            key={button.id}
            dir="ltr"
          >
            {authUser.is_admin && (
              <div
                className="btn-group d-inline-block"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <button
                  type="button"
                  className="btn btn-icon rounded-pill dropdown-toggle hide-arrow"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bx bx-dots-vertical-rounded"></i>
                </button>
                <ul className="dropdown-menu ">
                  <li
                    onClick={() => {
                      handleChangeNameButton(button);
                    }}
                  >
                    <a className="dropdown-item">تغییر نام</a>
                  </li>
                  <li onClick={(e) => handleRemoveButton(e, button)}>
                    <a className="dropdown-item">حذف</a>
                  </li>
                </ul>
              </div>
            )}
            <label
              htmlFor="html5-text-input"
              className="col-sm-4 col-form-label text-end text-sm-center"
            >
              <p className="m-0 p-0">{button.name}</p>
              S/{devices.find((d) => d.id == button.device_id).serial}/
              {button.digit}/{(button.data2 << 8) | button.data3}
            </label>
            <div className="col-sm-8">
              <div className="d-flex align-items-center justify-content-end flex-wrap gap-2">
                <input
                  className="form-control mt-1"
                  style={{ width: "100%", maxWidth: "10rem" }}
                  placeholder="مقدار"
                  type="number"
                  step="any"
                  value={inputValue || ""}
                  onChange={(e) =>
                    handleChangeSingleRegisterValue(button, e.target.value)
                  }
                  dir="rtl"
                  id="html5-text-input"
                />
                <span className="mx-1">×</span>
                <span className="mx-1">{button.data5}</span>
                <span className="mx-1">=</span>
                <span className="mx-1">{displayMultiplied}</span>
                <button
                  type="button"
                  className="btn btn-icon btn-success-app mx-2 mt-1"
                  onClick={() => handleSendSingleRegisterValue(button)}
                >
                  <span
                    className="tf-icons bx bx-send"
                    style={{ transform: "rotate(-20deg)" }}
                  ></span>
                </button>
              </div>
            </div>
          </div>
        );
      }
    });
  };

  return (
    <Fragment>
      <div
        className="card h-100 w-100"
        style={{ backgroundColor: "#fff0", boxShadow: "none" }}
      >
        <div
          className="card-header d-flex align-items-center justify-content-between border-bottom mb-3 p-0 pt-2"
          style={{ zIndex: "1" }}
        >
          <h5>
            {equipments.find((eq) => eq.id == eq_id)?.equipment?.name ?? ""}
          </h5>
          <div>
            <button
              type="button"
              className="btn btn-icon btn-success-app mx-3"
              onClick={() => setUpdate((prev) => !prev)}
            >
              <span className="tf-icons bx bx-refresh"></span>
            </button>
            {authUser.is_admin ? (
              <>
                <button
                  type="button"
                  className="btn btn-success-app btn-icon me-2"
                  style={{ borderColor: "rgb(0, 165, 148)" }}
                  onClick={() => handleRemoveEquipment(selectedEquipment.id)}
                >
                  <i className="bx bx-trash"></i>
                </button>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-success-app btn-icon dropdown-toggle hide-arrow"
                    style={{ borderColor: "rgb(0, 165, 148)" }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEquipmentsListModal(true);
                        }}
                      >
                        افزدون تجهیز
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        to={
                          "/room/select-device/" +
                          room_id +
                          "/" +
                          eq_id +
                          "/" +
                          eq_type
                        }
                      >
                        افزدون کانال به تجهیز
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item"
                        onClick={(e) => {
                          handleChangeEquipmentName(
                            equipments.find((eq) => eq.id == eq_id)?.id,
                          );
                        }}
                      >
                        تغییر نام تجهیز
                      </Link>
                    </li>
                  </ul>
                </div>
              </>
            ) : null}

            {/* <BackButton url={"/room/" + room_id} /> */}
          </div>
        </div>
        <div
          className="card-body scrollbar mt-4 mx-auto w-100"
          style={{ paddingBottom: "10rem" }}
        >
          {buttons.filter((btn) => btn.data1 == 1 || btn.data1 == 2).length >
            0 && (
            <div className="card mt-2">
              {/* <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="card-title mb-0">آمار وب‌سایت</h5>
            </div> */}
              <div className="card-body pb-2" style={{ position: "relative" }}>
                {renderFirstBox()}
              </div>
            </div>
          )}
          {buttons.filter((btn) => btn.data1 == 3 || btn.data1 == 4).length >
            0 && (
            <div className="card mt-2">
              <div className="card-body pb-2" style={{ position: "relative" }}>
                <div className="table-responsive text-nowrap">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>عملیات</th>
                        <th>مقدار</th>
                        <th>نام</th>
                      </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                      {renderSecondBox()}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {buttons.filter((btn) => btn.data1 == 5).length > 0 && (
            <div className="card mt-2">
              <div
                className="card-body"
                style={{ position: "relative", paddingBottom: "10rem" }}
              >
                <div className="d-flex flex-wrap justify-content-between justify-content-sm-start">
                  {renderThirdBox()}
                </div>
              </div>
            </div>
          )}

          {buttons.filter((btn) => btn.data1 == 6).length > 0 && (
            <div className="card mt-2 mb-3">
              <div className="card-body pb-2" style={{ position: "relative" }}>
                {renderFourthBox()}
              </div>
            </div>
          )}
        </div>
      </div>
      <SetDataFormat buttonShouldBeChange={buttonShouldBeChange} />
      <EditChartNumberModal button={buttonShouldBeChange} />
      <DefineChartModal
        button={buttonShouldBeChange}
        device={buttonShouldBeChange.device}
        chartCount={16}
        hasCycle={true}
        hasStatus={true}
        hasDataAddress={true}
        hasSlaveAddress={true}
        hasFunctionCode={true}
        hasQuantity={true}
        hasSubmitKey={true}
        hasSendOnChange={true}
      />
    </Fragment>
  );
};

export default React.memo(DataLogger);
//
